import { render } from "./BlockInsertZone.vue?vue&type=template&id=71e56ab1&scoped=true"
import script from "./BlockInsertZone.vue?vue&type=script&lang=js"
export * from "./BlockInsertZone.vue?vue&type=script&lang=js"

import "./BlockInsertZone.vue?vue&type=style&index=0&id=71e56ab1&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e56ab1"]])

export default __exports__